// Attendance API functions
import { getData, deleteData, postData, putData } from '../apiClient';

const API_URL = "attendance";

// Get attendance with pagination
export const getAttendanceWithPagination = async ({ page = 1, limit = 10, search = '' }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search
        });

        const result = await getData(`/${API_URL}/list?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get attendance API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: [],
                totalPages: 1,
                prevPage: false,
                nextPage: false,
                totalDocs: 0,
                page: 1
            }
        };
    }
};

// Get single attendance by ID
export const getAttendanceById = async (id) => {
    try {
        const result = await getData(`/${API_URL}/view/${id}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get attendance by ID API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: null
            }
        };
    }
};

// Create new attendance
export const createAttendance = async (data) => {
    try {
        const result = await postData(`/${API_URL}/create-attendance`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Create attendance API error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.error : error.message,
                status: error.status,
            },
        };
    }
};

// Automated Check-in
export const checkInAttendance = async (employee_id) => {
    try {
        const result = await postData(`/${API_URL}/check-in`, { employee_id });
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error("Check-in API error:", error);
        return { success: false, error: error.message };
    }
};

// Automated Check-out
export const checkOutAttendance = async (employee_id) => {
    try {
        const result = await postData(`/${API_URL}/check-out`, { employee_id });
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error("Check-out API error:", error);
        return { success: false, error: error.message };
    }
};

// Automated Check-out by Record ID
export const checkOutById = async (id) => {
    try {
        const result = await putData(`/${API_URL}/check-out-record/${id}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error("Check-out by ID API error:", error);
        return { success: false, error: error.message };
    }
};

// Update attendance
export const updateAttendance = async (id, data) => {
    try {
        const result = await putData(`/${API_URL}/update-attendance/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error('Update attendance API error:', error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.data.error : error.message,
                status: error.status,
            },
        };
    }
};

// Delete attendance
export const deleteAttendance = async ({ id }) => {
    try {
        const result = await deleteData(`/${API_URL}/delete-attendance/${id}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Delete attendance API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: null
            }
        };
    }
};

// Get all employees for select
export const getAllEmployees = async () => {
    try {
        const result = await getData(`/${API_URL}/employees`);
        return {
            data: {
                success: true,
                data: result.data || result, // Handle if result is already result.data
            },
        };
    } catch (error) {
        console.error(`Get Employees API error:`, error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};
